import { DotLabel } from "components/Dot";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";

interface Props {
  log: server.dto.ExternalCalendarRefresh
}

export const RefreshLogRow = (props: Props) => {
  const splitMessage = props.log.message.split("\n");
  const statusMessage = splitMessage[0];
  const details = splitMessage.length > 1 ? splitMessage[1] : null;

  return <div className="flex-column gap-mini">
    <DotLabel dotColor={props.log.isSuccess ? "green" : "red"}>{statusMessage}</DotLabel>
    <div>
      {details && <div className="flex">
        <div style={{ width: 3 }} className="gray-bg"></div>
        <div className="grow1 padding-small">
          {details}
        </div>
      </div>}
    </div>
    <div className="grow1 s1_small" title={formatWrittenDateTimeUtc(moment.utc(props.log.timestampUtc))}>
      <span className="s1_gray">{moment.utc(props.log.timestampUtc).fromNow()}</span>
    </div>
  </div>
}